import React from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel } from "@aureskonnect/react-ui";
import MultiCustomCreatableSelection from "@components/Common/MultiCustomCreatableSelection";
import { t } from "i18next";

interface Props {
    isConsult: boolean;
    tagsData: string[];
    setTagsData: (data: string[]) => void;
    tags: any[];
    formatCreateLabelTag: Function;
    isSendingTag: boolean;
    setIsEdited: (v: boolean) => void;
    clearMultiCustomSelectionData?: () => void;
}

const TagsSelection: React.FC<Props> = ({
    isConsult,
    tagsData,
    setTagsData,
    tags,
    formatCreateLabelTag,
    isSendingTag,
    setIsEdited,
}) => {
    return (
        <AvGroup className={`${isConsult ? "pe-none__clz" : ""}`}>
            <StyledLabel htmlFor="text" className="mt-3">
                {t("Tag")}
            </StyledLabel>
            <MultiCustomCreatableSelection
                onDelete={() => setIsEdited(true)}
                isSendingTag={isSendingTag}
                setResult={setTagsData}
                result={tagsData}
                data={tags}
                onChange={() => setIsEdited(true)}
                onCreateOption={() => setIsEdited(true)}
                placeholder={`${t("Select")}…`}
                value={t("Choose")}
                name="tag"
                noOptionsMessage={() => t("No options")}
                formatCreateLabel={formatCreateLabelTag}
                className="sdv_inp_FRtags"
            />
        </AvGroup>
    );
};

export default TagsSelection;
